import { render, staticRenderFns } from "./writeResultPresent.vue?vue&type=template&id=2a6af4e7&scoped=true&"
import script from "./writeResultPresent.vue?vue&type=script&lang=js&"
export * from "./writeResultPresent.vue?vue&type=script&lang=js&"
import style0 from "./writeResultPresent.vue?vue&type=style&index=0&id=2a6af4e7&scoped=true&lang=css&"
import style1 from "./writeResultPresent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6af4e7",
  null
  
)

export default component.exports